module.exports = __webpack_public_path__ + "img/belarus.dcfa26a.webp";